import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";
import { useApiClient } from "../../../../shared/customHooks";
import { supportTypeFormLegacy } from "../../../../shared/formObjects/application/legacy/supportTypeFormLegacy";
import { INavItem } from "../../../../shared/GlobalContext";
import { useApplicationContext } from "../../context/applicationContext";

function SupportTypeComponentLegacy({ disabled, data }: any) {
  const api = useApiClient("SupportTypeLegacy");
  const { id } = useApplicationContext();

  const customNav: INavItem = {
    label: "Type of Support",
    id: "TypeOfSupport",
    items: [
      {
        label: "Additional Assistant",
        id: "additionalAssistant",
      },
      {
        label: "Specialist Consultancy",
        id: "specialistConsultancy",
      },
      {
        label: "Specialist Training",
        id: "specialistTraining",
      },
      {
        label: "Minor Building Works",
        id: "minorWorks",
      },
    ],
  };
  return (
    <BaseApplicationComponent
      formBody={supportTypeFormLegacy}
      headerLabel="Type of Support"
      editPath="supportType"
      apiClient={api}
      disabled={disabled}
      data={data}
      customNav={customNav}
      id={id}
    />
  );
}

export default SupportTypeComponentLegacy;
